<template>
  <div class="ab-upload-panel">


    <Upload ref="upload" multiple
            :action="action"
            :with-credentials="true"
            :on-success="success"
            :on-remove="remove"
            :on-preview="preview"
            :show-upload-list="false"
            :accept="accept"
            :format="format"
            :on-format-error="formatError" :on-error="error"

            :before-upload="beforeUpload"
            :data="uploadData"
            :type="uploadProps.isImgUpload?'drag':'select'"
            :style="uploadProps.isImgUpload?'display: inline-block;':''"
    >

      <template v-if="uploadProps.isImgUpload">
        <div v-if="abPermission=='b'||abPermission=='w'" :style="uploadProps.previewImgStyle">
          <Icon type="ios-camera" size="20"></Icon>
        </div>
      </template>
      <template v-else>
        <Button v-if="abPermission=='b'||abPermission=='w'" :style="style" type="primary" shape="circle"
                icon="ios-cloud-upload-outline">
          <slot></slot>
        </Button>
      </template>

    </Upload>

    <template v-if="uploadProps.isImgUpload">
      <div class="images-upload-list" :style="uploadProps.previewImgStyle" v-for="item in uploadList"
           :key="item.response?item.response.data:item.name + Math.random()">
        <template v-if="item.status === 'finished'">
          <img :src="`${previewBaseUrl}${item.response.data}&isThumbnail=${uploadProps.isMakeThumbnail?'1':'0'}`">
          <div class="images-upload-list-cover">
            <Icon type="ios-eye-outline" @click.native="previewImg(item)"></Icon>
            <Icon v-if="abPermission=='b'||abPermission=='w'" type="ios-trash-outline"
                  @click.native="removeImg(item)"></Icon>
          </div>
        </template>
        <template v-else>
          <Progress v-if="item.showProgress" :percent="item.percentage" hide-info></Progress>
        </template>
      </div>
    </template>
    <template v-else>
      <!-- 外层容器：控制横向排列 -->
      <div class="file-upload-container">
        <div
            class="file-upload-list"
            v-for="(item, index) in uploadList"
            :key="index"
        >
          <div class="file-name" :title="item.name" @click="preview(item)">
            {{ item.name }}
          </div>
          <div class="file-opt">
            <Icon
                :title="$t('page.common.del')"
                v-if="isShowDeleteBtn"
                type="md-trash"
                @click="removeImg(item)"
            />
          </div>
        </div>
      </div>
    </template>
    <div>
      <preview-image v-model="isPreview" :src="fileViewId?previewBaseUrl + fileViewId:''"
                     z-index="9000"></preview-image>
    </div>

  </div>
</template>

<script>
import Setting from '@/setting'
import PreviewImage from "@/components/preview-image";

/**
 * <ab-upload v-model="data.kjcs.fjsc">​</ab-upload>
 */
export default {
  props: ['value', 'abPermission', 'accept', 'format', 'imgParam', 'isImg','isShowDeleteBtn'

  ],
  components: {PreviewImage},
  data: function () {
    return {
      action: "",
      style: "",
      uploadList: [],

      uploadData: {},
      isPreview: false, //预览标识符
      previewBaseUrl: Setting.apiBaseURL + "sys/sysFile/download?fileId=", //预览地址
      fileViewId: '', //附件预览id
      modalParam: {
        title: "文件预览"
      },
      uploadProps: {
        isImgUpload: this.isImg | false, //是否图片上传
        isMakeThumbnail: true, //是否制作缩略图
        previewImgStyle: { //预览样式，宽高设置
          width: "80px",
          height: "80px",
          lineHeight: "80px"
        }
      }
    }
  },
  mounted: function () {
    this.action = Setting.apiBaseURL + "sys/sysFile/upload";
    this.uploadList = this.$refs.upload.fileList;

    //上传图片参数
    if (this.imgParam) {
      try {
        Object.assign(this.uploadProps, this.imgParam);
      } catch (e) {
        console.log(e);
      }
    }
    // 图片时，只能上传图片类型
    if (this.uploadProps.isImgUpload) {
      this.format = ['jpg', 'png', 'gif', 'bpm']
    }
    if (this.value && this.abPermission != 'n') {//初始化数据
      JSON.parse(this.value).forEach(json => {
        this.uploadList.push({
          name: json.name,
          status: "finished",
          response: {
            data: json.id
          }
        });
      });
    }

    this.handleStyle();
  },
  methods: {
    isShowEye(item) {
      const list = item.name.split('.')
      const fileType = list[list.length - 1]
      const typeList = ['png', 'jpg', 'jpeg', 'pdf']
      return typeList.indexOf(fileType) !== -1
    },
    previewFile(item) {
      const fileType = item.name.split('.')[1]
      const imgTypeList = ['png', 'jpg', 'jpeg']
      if (imgTypeList.indexOf(fileType) !== -1) {
        this.previewImg(item)
        return
      }
      let routeUrl = this.$router.resolve({
        path: "/pdf/pdfView",
        query: {
          id: item.response.data,
        }
      });
      let pageUrl = routeUrl.href;
      window.open(pageUrl, '_blank', "width=1920,height=1080,menubar=0,scrollbars=1,resizable=1,status=1,titlebar=0,toolbar=0,location=1");
    },
    beforeUpload: function (file) {
      //附件上传前相关处理
      if (this.uploadProps && this.uploadProps.isMakeThumbnail && this.uploadProps.isImgUpload) {
        this.uploadData.isMakeThumbnail = 1;
      }
      return true;
    },
    success: function (response, file, fileList) {
      if (response && !response.isOk) {
        this.abTools.ArrayUtil.remove(file, fileList)
        this.$Message.error(response.msg);
        return;
      }
      let list = [];
      fileList.forEach(item => {
        let json = {
          name: item.name,
          id: item.response.data
        };
        list.push(JSON.stringify(json));
      });
      this.$emit('input', "[" + list.join(",") + "]");
    },
    remove: function (file, fileList) {
      this.success(null, file, fileList);
    },
    preview: function (file) {

      let url = this.previewBaseUrl + file.response.data;
      window.open(url, "_blank");
    },
    removeImg: function (file) {

      const fileList = this.$refs.upload.fileList;
      this.$refs.upload.fileList.splice(fileList.indexOf(file), 1);

      this.success(null, file, fileList);
    },
    previewImg: function (file) { //图片预览
      this.fileViewId = file.response.data;
      this.isPreview = true;
      this.modalParam.title = file.name;
    },
    handleStyle: function () {
      if (!this.$vnode.context.$validity) {
        this.$vnode.context.$validity = {};
      }
      if (this.abPermission == "b") {
        if (!this.value || this.value == "[]") {
          this.$vnode.context.$validity[this.$attrs.desc] = "必填";
          this.style = "border: 1px solid #ed4014;";
        } else {
          delete this.$vnode.context.$validity[this.$attrs.desc];
          this.style = "";
        }
      }// 动态权限后切换权限
      else if (this.$vnode.context.$validity[this.$attrs.desc]) {
        delete this.$vnode.context.$validity[this.$attrs.desc];
        this.style = "";
      }
    },
    formatError(file, fileList) {
      this.$Message.error("仅支持文件类型：" + this.format.join(","));
    },
    error(error, file, fileList) {
      this.$Message.error("未知上传错误，请联系管理员（大概率附件内容过大（服务器级别））");
    }
  },
  watch: {
    value: function (oldValue, newValue) {
      this.handleStyle();
    },
    abPermission: function () {
      this.handleStyle();
    }
  }
}
</script>

<style lang="less" scoped>

.ab-upload-panel {
  flex-direction: column;

  .images-upload-list {
    display: inline-block;
    text-align: center;
    border: 1px solid transparent;
    border-radius: 4px;
    overflow: hidden;
    background: #fff;
    position: relative;
    box-shadow: 0 1px 1px rgba(0, 0, 0, .2);
    margin-right: 4px;

    img {
      width: 100%;
      height: 100%;
    }

    .images-upload-list-cover {
      display: none;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      background: rgba(0, 0, 0, .6);

      i {
        color: #fff;
        font-size: 20px;
        cursor: pointer;
        margin: 0 2px;
      }

    }

  }

  .images-upload-list:hover .images-upload-list-cover {
    display: block;
  }

}
/* 外层容器：横向排列，允许换行 */
.file-upload-container {
  display: flex;
  flex-wrap: wrap; /* 超出宽度自动换行 */
  gap: 6px; /* 项之间的间距（替代 margin） */
  margin-bottom: 8px;
}

/* 每个文件项：宽度由内容决定 */
.file-upload-list {
  display: flex;
  align-items: center;
  background: #f3f3f3;
  border-radius: 2px;
  padding: 4px 4px 4px 8px; /* 右侧留出图标空间 */
  cursor: pointer;
  position: relative;
  max-width: 300px; /* 防止单个文件名过长撑破布局（可选） */
}

/* 文件名：自动省略超长文本 */
.file-upload-list .file-name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1; /* 占据剩余空间 */
}

.file-upload-list .file-name:hover {
  color: #2d8cf0;
}

/* 操作图标：固定在右侧 */
.file-upload-list .file-opt {
  flex-shrink: 0; /* 不被压缩 */
  margin-left: 6px;
}

.file-upload-list .ivu-icon {
  font-size: 16px;
  color: #515a6e;
}

.file-upload-list .ivu-icon:hover {
  color: #2d8cf0;
}
</style>
